/*global angular */
/*jslint node: true */

'use strict';

var add = require('./add/add-directive.js'),
    address = require('./address/address-directive.js'),
    headline = require('./headline/headline-directive.js'),
    spacer = require('./spacer/spacer-directive.js'),
    image = require('./image/image-directive.js'),
    quote = require('./quote/quote-directive.js'),
    logo = require('./logo/logo-directive.js'),
    nav = require('./nav/nav-directive.js'),
    link = require('./link/link.js'),
    text = require('./text/text.js'),
    youtube = require('./youtube/youtube.js');

require('./socialmedia/socialmedia.js');

var slots = angular.module('slots', ['add', 'address', 'spacer', 'image', 'logo', 'text', 'link', 'youtube', 'socialmedia',
    'nav', 'quote', 'headline']);


/**
 * @param mod {String} - module name
 * @returns {[String,String]}
 */
function listServices(mod) {
    var result = [];
    angular.forEach(angular.module(mod).requires, function (m) {
        result = result.concat(listServices(m));
    });
    //noinspection JSUnresolvedVariable
    angular.forEach(angular.module(mod)._invokeQueue,
        function (a) {
            result.push([a[2][0], a[1]]); // a[1] == type == factory|directive|...
        });
    return result;
}


slots.directive('configRenderer', ['$compile', function ($compile) {
    return {
        scope: {
            custom: "=", // template
            subject: "=",
            ext: "="
        },
        restrict: 'E',
        link: function (scope, element) {
            var linkFn = $compile(scope.custom);
            var content = linkFn(scope);
            element.append(content);
        }
    };
}]);


/** @type {Object.<string, msDynamicSlot|{}>} */
var detectedSlots = {}, detectedSlotsInitialized = false;

slots.service('msDynamicSlots', [function () {
    return detectedSlots;
}]);

/**
 * render directive-slots or service-slots
 */
slots.directive('dynamicSlotRenderer', ['$injector', '$compile', 'OptionSidebar', function ($injector, $compile, OptionSidebar) {
    return {
        link: function (scope, element) {
            var type = scope.slot.type;

            if (!detectedSlotsInitialized) {
                detectedSlotsInitialized = true;
                listServices('slots').forEach(function (item) {
                    var name = item[0], type = item[1], slot = item[0];

                    if (name.substr(name.length - 4, 4) == 'Slot') {
                        slot = name.substr(0, name.length - 4);
                    }

                    detectedSlots[slot] = {
                        key: slot,
                        name: name,
                        type: type,
                        service: null,
                        directive: null
                    };

                    if (type == 'service') {
                        detectedSlots[slot].service = $injector.get(name);
                        if (detectedSlots[slot].service.config) {
                            //todo console.debug("added custom config for slot ", detectedSlots[slot]);
                            OptionSidebar.registerEntry(detectedSlots[slot].service.config);
                        }

                    } else if (type == 'directive') {
                        var tmp = name.substr(0, 1).toUpperCase() + name.substr(1);
                        detectedSlots[slot].directive = tmp.match(/[A-Z][a-z]+/g).join('_').toLowerCase();
                    }
                    scope.editing.detectedSlots = detectedSlots;
                });
            }

            if (type == 'empty') type = 'spacer'; // lazy migration TODO remove
            if (type == 'list') type = 'footerSection'; // lazy migration TODO remove

            var template = null;
            var slot = detectedSlots[type];


            if (!slot) {
                // todo: handle error console.log('Slot', '"' + type + '"', 'not found!');
                return;
            }

            if (slot.service) {
                template = slot.service.getTemplate();
            } else {
                template = '<' + slot.directive + '></' + slot.directive + '>';
            }

            setTimeout(function () {
                var linkFn = $compile(template);
                var content = linkFn(scope);
                element.append(content);
            });
        }
    };
}]);